import React from "react";
import api from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import { TextInput, PasswordInput, Button, Container, Title, Stack, Paper, Alert } from "@mantine/core";
import { MSIcon } from "components/MSIcon.jsx";
import { useTrans } from "core/index.js";

export default function Login() {
	const [input, setInput] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const { t } = useTrans();
	const [inputError, setInputError] = React.useState(null);
	const [passwordError, setPasswordError] = React.useState(null);
	const [globalError, setGlobalError] = React.useState(null);

	const navigate = useNavigate();

	const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
	const phoneRegex = /^[0-9]{8,15}$/;

	const validate = () => {
		let valid = true;

		setInputError(null);
		setPasswordError(null);
		setGlobalError(null);

		if (!input) {
			setInputError(t("messages.errors.signin.fieldRequired.EmailOrMobile"));
			valid = false;
		} else if (!emailRegex.test(input) && !phoneRegex.test(input)) {
			setInputError(t("messages.errors.signin.emailPhone"));
			valid = false;
		}

		if (!password) {
			setPasswordError(t("messages.errors.signin.fieldRequired.passwordRequired"));
			valid = false;
		}

		return valid;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validate()) return;

		setLoading(true);
		try {
			const payload = { email: input.trim(), password };
			const res = await api.signin(payload);

			navigate("/");
		} catch (err) {
			const message = err?.data?.message || err.message || "Login failed";
			setGlobalError(t(message));
		} finally {
			setLoading(false);
		}
	};

	return (
		<Container size={420} my={40}>
			<Title align="center" order={2} mb={20}>
				{t("login.login")}
			</Title>

			<Paper withBorder shadow="md" p={30} radius="md">
				{globalError && (
					<Alert icon={<MSIcon name="alert-circle" />} title="Error" color="red" mb={15}>
						{globalError}
					</Alert>
				)}
				<form onSubmit={handleSubmit}>
					<Stack>
						<TextInput
							label={t("login.emailOrPhone")}
							placeholder={t("login.emailOrPhone")}
							value={input}
							onChange={(e) => setInput(e.target.value)}
							error={inputError}
						/>
						<PasswordInput
							label={t("login.password")}
							placeholder={t("login.password")}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							error={passwordError}
						/>
						<Button type="submit" loading={loading} fullWidth>
							{loading ? `${t("login.login")}...` : t("login.login")}
						</Button>
					</Stack>
				</form>
			</Paper>
		</Container>
	);
}
